import { GatewayStatus } from 'constants/gatewayStatuses';
import { Resources } from 'constants/resources';

import { useState } from 'react';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordContext } from 'react-admin';
import { Tab } from 'shared/mui/Tab/Tab';
import { TabPanel } from 'shared/mui/TabPanel/TabPanel';
import { Tabs } from 'shared/mui/Tabs/Tabs';
import { Gateway } from 'types/embedded/gateway';

import { GatewayShowInfoTable } from './GatewayShowInfoTable';
import { GatewaysShowTableMethodsDatagrid } from './GatewaysShowTableMethodsDatagrid';

export const GatewaysShowTable: React.FC = () => {
  const record = useRecordContext<Gateway>();
  const [value, setValue] = useState(0);

  const { hasResourceAccess } = usePermissions();
  const isPilot = record?.status?.value === GatewayStatus.Pilot;

  return isPilot && record?.gatewayMethods?.length ? (
    <>
      <Tabs onChange={(_, newValue) => setValue(newValue)} value={value}>
        <Tab label="Информация" value={0} />
        <Tab label={`Методы (${record?.gatewayMethods?.length})`} value={1} />
      </Tabs>
      <TabPanel index={0} value={value}>
        <GatewayShowInfoTable />
      </TabPanel>
      <TabPanel index={1} value={value}>
        {isPilot && hasResourceAccess(Resources.Methods) && <GatewaysShowTableMethodsDatagrid />}
      </TabPanel>
    </>
  ) : (
    <GatewayShowInfoTable />
  );
};
